/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* James Crossing customizations (custom.js is loaded on every page with defer). */
(() => {
  /* Announcement bar links that point to a homepage FAQ item (#faq-...) open in a new tab. */
  function faqLinksNewTab() {
    document.querySelectorAll('.announcement a[href*="#faq-"]').forEach((link) => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener');
    });
  }

  /* Deep links: /#faq-<section-id>-<n> opens that FAQ accordion item and scrolls to it. */
  function openFaqFromHash() {
    let id = '';
    try {
      id = decodeURIComponent(window.location.hash.slice(1));
    } catch (e) {
      return;
    }
    if (!id) return;
    const details = document.getElementById(id);
    if (!details || details.tagName !== 'DETAILS') return;
    const group = details.closest('accordion-group');

    const scrollToItem = () => {
      let offset = 24;
      const header = document.querySelector('.js-header');
      if (header && header.classList.contains('js-header-sticky')) offset += header.offsetHeight;
      const top = details.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    };

    const reveal = () => {
      if (!details.open) {
        if (group && typeof group.open === 'function') group.open(id);
        else details.open = true;
      }
      scrollToItem();
      /* Re-align once lazy images above the FAQ have loaded and shifted the layout. */
      if (document.readyState !== 'complete') {
        window.addEventListener('load', () => setTimeout(scrollToItem, 350), { once: true });
      }
    };

    if (group && window.customElements) {
      customElements.whenDefined('accordion-group').then(() => requestAnimationFrame(reveal));
    } else {
      reveal();
    }
  }

  function init() {
    faqLinksNewTab();
    openFaqFromHash();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('hashchange', openFaqFromHash);
})();

/* Header dropdowns with long lists (e.g. Artists), 2026-10-07: jc-header-menu.css picks the
   column count from the window size. This script marks the long lists, records where the panel
   starts (so the height cap is exact, including with the sticky header), keeps a wide panel on
   screen, and keeps wheel/trackpad scrolling inside the open panel so it doesn't scroll the page
   (which hid the sticky header and closed the menu, especially in Firefox). */
(() => {
  const LONG_AFTER = 10;

  function setup(details) {
    const sub = details.querySelector(':scope > .nav__sub');
    const wrap = sub && sub.querySelector(':scope > .nav__sub-wrap');
    const list = wrap && wrap.querySelector(':scope > .list-menu');
    if (!list || wrap.dataset.jcNavLong) return;
    const count = list.querySelectorAll(':scope > .list-menu__item').length;
    if (count <= LONG_AFTER) return;
    wrap.dataset.jcNavLong = '1';
    wrap.classList.add('jc-nav-long');

    const fit = () => {
      if (!details.open) return;
      sub.classList.remove('jc-nav-shift');
      sub.style.removeProperty('--jc-nav-shift');
      const rect = wrap.getBoundingClientRect();
      wrap.style.setProperty('--jc-nav-top', `${Math.round(Math.max(0, rect.top))}px`);
      const overflowRight = rect.right - (window.innerWidth - 24);
      if (overflowRight > 0) {
        sub.style.setProperty('--jc-nav-shift', `${-Math.min(overflowRight, Math.max(0, rect.left - 24))}px`);
        sub.classList.add('jc-nav-shift');
      }
    };
    details.addEventListener('toggle', () => requestAnimationFrame(fit));
    window.addEventListener('resize', fit);

    wrap.addEventListener(
      'wheel',
      (event) => {
        if (!details.open || event.ctrlKey) return;
        const max = wrap.scrollHeight - wrap.clientHeight;
        const dy = event.deltaY;
        if (max <= 1 || (dy < 0 && wrap.scrollTop <= 0) || (dy > 0 && wrap.scrollTop >= max - 1)) {
          event.preventDefault();
        }
      },
      { passive: false },
    );
  }

  function init() {
    document.querySelectorAll('.primary-nav header-details-disclosure:not(.mega) > details').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
